import React from 'react';

const ProgressBar = ({ progress, status = 'on-track' }) => {
  const getProgressColor = () => {
    switch (status) {
      case 'on-track':
      case 'completed':
        return 'bg-green-500';
      case 'at-risk':
        return 'bg-yellow-500';
      case 'overdue':
        return 'bg-red-500';
      default:
        return 'bg-purple-500';
    }
  };

  return (
    <div className="w-full bg-white/10 rounded-full h-2 overflow-hidden">
      <div
        className={`h-full transition-all duration-500 ${getProgressColor()}`}
        style={{ width: `${Math.min(progress, 100)}%` }}
      />
    </div>
  );
};

export default ProgressBar;